import React, { memo, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { selectionStoreChangesService } from "../../services/selection-store-changes.service";
import GolCalendar from "../calendar/gol-calendar/gol-calendar";
import { useLocation } from "react-router-dom";
import DailyAvailabilitiesFetcher from "./daily-availabilities-fetcher";
import { selectionStore } from "../../stores/selection.store";

interface IStyled {
  disabled?: boolean;
}

const CalendarWrapper = styled.div<IStyled>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2px;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  opacity: ${(props) => (props.disabled ? 0.8 : 1)};
}
`;
export enum GolEventListener {
  Guests = "guests",
  CalendarDate = "calendar-date",
  CalendarMonth = "calendar-month",
  Period = "period",
  Area = "area",
  OnComplete = "onComplete",
  Time = "time",
}

interface CalendarProps {
  fetchData?: boolean;
}

const Calendar = (props: CalendarProps) => {
  const [selectedGuests, setSelectedGuests] = useState(selectionStore.guests);
  const [fetchData, setFetchData] = useState(props.fetchData ?? true);
  const error = useRef<{ [key: string]: string } | null>(
    useLocation().state as { [key: string]: string } | null
  );

  useEffect(() => {
    selectionStoreChangesService.registerListener(
      "calendar",
      [
        GolEventListener.CalendarMonth,
        GolEventListener.Period,
        GolEventListener.Area,
        GolEventListener.Guests,
      ],
      () => {
        error.current = null;
        setSelectedGuests(selectionStore.guests);
        if (selectionStore.guests > 0) {
          setFetchData(true);
        }
      }
    );

    return () => {
      selectionStoreChangesService.unregisterListener("calendar");
    };
  }, []);

  useEffect(() => {
    selectionStoreChangesService.registerListener(
      "calendar-on-complete",
      [GolEventListener.OnComplete],
      () => {
        setFetchData(false);
      }
    );

    return () => {
      selectionStoreChangesService.unregisterListener("calendar-on-complete");
    };
  }, []);

  const renderCalendar = () => {
    return (
      <CalendarWrapper
        data-test="calendar-wrapper"
        disabled={selectedGuests === 0}
      >
        <GolCalendar data-test="gol-calendar" />
      </CalendarWrapper>
    );
  };

  return (
    <CalendarWrapper
      data-test="calendar-layout"
      disabled={selectedGuests === 0}
    >
      {fetchData ? (
        <DailyAvailabilitiesFetcher data-test="daily-availabilities-fetcher" />
      ) : (
        renderCalendar()
      )}
    </CalendarWrapper>
  );
};
export const CalendarLayout = memo(Calendar);
